// extracted by mini-css-extract-plugin
export default {"root":"ReferenceGuideDialog_root__rCUtA"};